module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicWide-Regular-3144ba5968800b2d35602ebc716f7bd4.ttf";